import { computed } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { t } from '@/locales'

// Mirrors the "Generelt"/"Skabeloner" tab labels in SettingsReportsView.vue's
// own `menuSections` — kept as a separate, lightweight list here rather than
// reusing that computed directly, since it also carries route-active state
// that's irrelevant to the page lookup palette. Gated by the same
// `reportTemplates.view` check useSettingsMenuSections.ts uses for the
// generic "Rapporter" nav entry — these two entries sit alongside that one
// in the palette (see usePageLookupItems.ts), so both "Rapporter" and each
// individual tab are searchable. Update this alongside SettingsReportsView.vue
// if these tabs change. Collections (formerly "Beskrivelser") and Bilag both
// moved out to the top-level "Bibliotek" Settings section — see
// useSettingsMenuSections.ts — so neither is part of this Reports-scoped
// list any more.
export function useReportsTabs() {
  const userStore = useUserStore()

  return computed<{ label: string; routeName: string }[]>(() => {
    if (!userStore.canUser('reportTemplates.view')) return []
    return [
      { label: t('W: Skabeloner'), routeName: 'SettingsReportTemplates' },
      { label: t('W: Generelt'), routeName: 'SettingsReportSettings' },
    ]
  })
}
